import { render, staticRenderFns } from "./CategoriesSideBar.vue?vue&type=template&id=6587e07e&scoped=true"
import script from "./CategoriesSideBar.vue?vue&type=script&lang=js"
export * from "./CategoriesSideBar.vue?vue&type=script&lang=js"
import style0 from "./CategoriesSideBar.vue?vue&type=style&index=0&id=6587e07e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6587e07e",
  null
  
)

export default component.exports